import { keepPreviousData } from "@tanstack/react-query";
import { RouterOutputs, trpc } from "../trpc";

export type App = RouterOutputs["app"]["apps"]["results"][number];

interface Input {
  search?: string;
  enabled?: boolean;
  selectedApis?: string[];
}

export function useQueryApps({ search, enabled = true, selectedApis }: Input) {
  const { data, isLoading, isRefetching, isFetching } = trpc.app.apps.useQuery(
    {
      search,
      selectedApis,
    },
    { placeholderData: keepPreviousData, enabled },
  );

  return {
    apps: (data?.results || []) as App[],
    isFetching,
    isLoading,
    isRefetching,
  };
}
